import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import networkApi from "../api";
import { WhoIsReport } from "../@types";
import { networkKeys } from "../../samples/queryKeys";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../consts";

const { nti_toolkit_enabled: isNtiEnabled } = window.tcbase.consts;

const useWhoIsReport = (url: string) => {
  const {
    data: whoisData,
    isFetching,
    error
  } = useQuery({
    queryKey: networkKeys.whoIsReport(url),
    queryFn: () => networkApi.whoisReport({ url }),
    select: ({ data }: AxiosResponse<WhoIsReport>) => data,
    enabled: Boolean(url && isNtiEnabled),
    ...USEQUERY_DISABLE_REFETCH_OPTIONS
  });

  return {
    whoIsReport: whoisData,
    isLoadingWhoIsReport: isFetching,
    error
  };
};

export default useWhoIsReport;
